module.exports = __webpack_public_path__ + "static/media/miehuoqi2.6a2a9a4a.png";